import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Banner,
  Button,
  EmptyState,
  Stack,
  TAssetSource,
} from "@rentiohq/web-shared/dist/components";

interface IListLoadFailedProps {
  heading: string;
  icon: TAssetSource;
  onRetry: () => void;
}

interface ILoadFailedBannerProps {
  title: string;
  info: string;
  onRetry?: () => void;
}

// In place of a cost or settlement list whose fetch failed: an empty list
// would read as "nothing there".
export const ListLoadFailed = ({
  heading,
  icon,
  onRetry,
}: IListLoadFailedProps) => (
  <EmptyState
    heading={heading}
    icon={icon}
    action={{
      content: getLocalizedText("try.again"),
      onClick: onRetry,
      appearance: "outline",
    }}
  >
    {getLocalizedText("costs.overview.load_failed_body")}
  </EmptyState>
);

// The same failure above a screen that still shows what it can (a settlement
// wizard step, a confirmed settlement).
export const LoadFailedBanner = ({
  title,
  info,
  onRetry,
}: ILoadFailedBannerProps) => (
  <Banner title={title} variation="error" hasDismiss={false}>
    <Stack vertical spacing="tight">
      <span>{info}</span>
      {onRetry && (
        <Button appearance="outline" size="small" onClick={onRetry}>
          {getLocalizedText("try.again")}
        </Button>
      )}
    </Stack>
  </Banner>
);
